import RxTime from "@2kog/pkg-common/utils/rx-time";
const timeInstance = new RxTime();

export function formatDate(value, mode = "date") {
    if (value) {
        if (mode === "date") {
            return timeInstance.format(value, "YYYY-MM-DD");
        }
        if (mode === "time") {
            return timeInstance.format(value, "HH:mm:ss");
        }
        if (mode === "hour") {
            return timeInstance.format(value, "HH:mm");
        }
        if (mode === "datetime") {
            return timeInstance.format(value, "YYYY-MM-DD HH:mm:ss");
        }
    }
}

// 时间转换
export function formatTime(time, format = "YYYY-MM-DD HH:mm:ss") {
    const _time = new Date(time);
    return timeInstance.format(_time, format);
}

/**
 * 去除对象空值
 * @param {*} obj
 * @returns
 */
export function removeEmpty(obj) {
    const newObj = {};
    for (const key in obj) {
        if (obj[key] !== null && obj[key] !== undefined && obj[key] !== "") {
            newObj[key] = obj[key];
        }
    }
    return newObj;
}

// params 不确定的对象
export function removeEmptyParams(params) {
    const newParams = {};
    for (const key in params) {
        if (params[key] !== undefined && params[key] !== "") {
            newParams[key] = params[key];
        }
    }
    return newParams;
}

// 数组转tree
export function array2Tree(array, params = { parentKey: "parent_id", parentValue: 0, childrenKey: "children" }) {
    const tree = [];
    // 在数组中查找具有指定父ID的所有子项
    for (let i = 0; i < array.length; i++) {
        if (~~array[i][params.parentKey] === ~~params.parentValue) {
            // 递归调用，将子项转换为子树
            const children = array2Tree(array, { ...params, parentValue: array[i].id });

            if (children.length) {
                array[i][params.childrenKey] = children;
            }

            tree.push(array[i]);
        }
    }

    return tree;
}

// 多字段排序
export function sortBy(filed1, filed2) {
    return function (a, b) {
        if (a[filed1] === b[filed1]) {
            return a[filed2].localeCompare(b[filed2]);
        }
        return a[filed1].localeCompare(b[filed1]);
    };
}

// 导出csv
export function exportCsv(list, titles = []) {
    if (!titles.length) return list;
    const keys = titles.map((item) => item.key);
    const labels = titles.map((item) => item.label);
    const mapList = [];
    list.forEach((item) => {
        const newItem = [];
        keys.forEach((key) => {
            newItem.push(item[key]);
        });
        mapList.push(newItem.join(","));
    });
    mapList.unshift(labels.join(","));
    return mapList.join("\r\n");
}

// 导出xlsx
export function exportXlsx(list, titles = []) {
    if (!titles.length) return list;
    const keys = titles.map((item) => item.key);
    const labels = titles.map((item) => item.label);
    const mapList = [];
    list.forEach((item) => {
        const newItem = [];
        keys.forEach((key) => {
            newItem.push(item[key]);
        });
        mapList.push(newItem);
    });
    mapList.unshift(labels);
    return mapList;
}

// 是否只保留remainKey
export function arr2map({ array = [], key = "key", remainKey = "" } = {}) {
    if (
        !array?.length ||
        !array.every((item) => key in item) ||
        (remainKey && !array.every((item) => remainKey in item))
    ) {
        console.log("【参数错误】", array, key, remainKey);
        return {};
    }
    return array.reduce((acc, cur) => {
        return { ...acc, [cur[key]]: remainKey ? cur[remainKey] : cur };
    }, {});
}

export function map2arr(map) {
    return Object.entries(map).map(([key, value]) => {
        return {
            name: value,
            key: key,
        };
    });
}

export function dispatchEventStorage() {
    const _setItem = localStorage.setItem;

    localStorage.setItem = function (key, val) {
        // 注册一个名称为 setItemEvent 的事件
        let setEvent = new Event("setItemEvent");
        // key 为改变的 key， newVal 为改变的 value
        setEvent.key = key;
        setEvent.newVal = val;

        window.dispatchEvent(setEvent);

        _setItem.apply(this, arguments);
    };
}

export function formatNumber(num, fixed = 0, prefix = "") {
    if (!num || isNaN(num)) return `${prefix}0`;

    // 将数字转换为字符串，保留两位小数
    const formattedNumber = num.toFixed(fixed).replace(/\B(?=(\d{3})+(?!\d))/g, ","); // 每三位添加一个逗号

    return `${prefix}${formattedNumber}`;
}

/**
 * 格式化股票成交额（人民币）
 * @param {number} amount - 原始成交额（单位：元）
 * @param {'zh'|'en'} lang - 语言类型，默认为 'zh'
 * @returns {string} 格式化后的金额字符串
 *
 * 示例：
 * formatStockAmount(1234567890000, 'zh') => "12345.68亿"
 * formatStockAmount(1234567890000, 'en') => "1234.57B CNY"
 */
export function formatStockAmount(amount, lang = "zh-CN") {
    if (amount === 0) return 0;
    if (typeof amount !== "number" || isNaN(amount)) {
        return lang === "zh-CN" ? "无数据" : "N/A";
    }

    // 输入金额已经是元为单位
    const yuan = amount;

    if (lang === "zh-CN") {
        if (yuan >= 1e8) return `${(yuan / 1e8).toFixed(2)}亿`;
        if (yuan >= 1e4) return `${(yuan / 1e4).toFixed(2)}万`;
        return `${yuan.toFixed(2)}元`;
    } else if (lang === "en-US") {
        if (yuan >= 1e9) return `${(yuan / 1e9).toFixed(2)}B CNY`;
        if (yuan >= 1e6) return `${(yuan / 1e6).toFixed(2)}M CNY`;
        if (yuan >= 1e3) return `${(yuan / 1e3).toFixed(2)}K CNY`;
        return `${yuan.toFixed(2)} CNY`;
    }

    throw new Error("Unsupported language type");
}

/**
 * 格式化比率函数（支持正负号和自定义除数）
 * @param {number} num - 要格式化的数字
 * @param {number} divisor - 除数（100/10000）
 * @param {number} fixed - 保留小数位数（默认0）
 * @returns {string} 格式化后的比率字符串
 */
export function formatRatio(num, divisor = 100, showSign = true, fixed = 2) {
    // 处理无效输入
    if (num === null || num === undefined || isNaN(num)) {
        return "0%";
    }

    // 计算实际比率值
    const ratio = num / divisor;

    // 确定符号（正数加+，负数保留-，0不加符号）
    const sign = ratio > 0 ? (showSign ? "+" : "") : ratio < 0 ? "-" : "";

    // 处理绝对值并格式化数字
    const absValue = Math.abs(ratio);
    const formattedNumber = absValue.toFixed(fixed).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return `${sign}${formattedNumber}%`;
}

export function formatETFPrice(price) {
    return (price / 1000).toFixed(3);
}

// 成交量
export function formatVolume(volume, lang = "zh-CN") {
    if (volume === 0) return 0;
    if (typeof volume !== "number" || isNaN(volume)) {
        return lang === "zh-CN" ? "无数据" : "N/A";
    }

    if (lang === "zh-CN") {
        if (volume >= 1e8) return `${(volume / 1e8).toFixed(2)}亿`;
        if (volume >= 1e4) return `${(volume / 1e4).toFixed(2)}万`;
        return `${volume.toFixed(2)}`;
    } else if (lang === "en-US") {
        if (volume >= 1e9) return `${(volume / 1e9).toFixed(2)}B`;
        if (volume >= 1e6) return `${(volume / 1e6).toFixed(2)}M`;
        if (volume >= 1e3) return `${(volume / 1e3).toFixed(2)}K`;
        return `${volume.toFixed(2)}`;
    }

    throw new Error("Unsupported language type");
}

export function normalizeMonth(s = "") {
    const txt = s.trim();
    const m = txt.match(/(\d{4})\s*年\s*(\d{1,2})\s*月/);
    if (m) {
        // eslint-disable-next-line no-unused-vars
        const [_, y, mo] = m;
        const mm = String(Number(mo)); // 去掉前导0
        return `${y}年${mm}月`;
    }
    return null;
}

export function getStrikesBySpot(strikes, spot) {
    // 对strikes数组进行排序
    const sortedStrikes = [...strikes].sort((a, b) => a - b);

    // 找到最接近spot的strike的索引
    let closestIndex = 0;
    let minDiff = Math.abs(sortedStrikes[0] - spot);

    for (let i = 1; i < sortedStrikes.length; i++) {
        const diff = Math.abs(sortedStrikes[i] - spot);
        if (diff < minDiff) {
            minDiff = diff;
            closestIndex = i;
        }
    }

    // 计算上下各3档的范围
    const startIndex = Math.max(0, closestIndex - 3);
    const endIndex = Math.min(sortedStrikes.length - 1, closestIndex + 3);

    // 返回范围内的strikes
    return sortedStrikes.slice(startIndex, endIndex + 1);
}
